import axios from "axios"
import { del, get, post, put, postFormData } from "./api_helper"
import * as url from "./url_helper"

// Cargos_Controller
const get_From_CargosController = jsonparameters => {
  return get(
    `${url.GET_FROM_CARGOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_CargosController = jsonparameters => {
  return post(
    `${url.POST_TO_CARGOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_CargosController_FormData = (jsonparameters, formData) => {
  return postFormData(
    `${url.POST_TO_CARGOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters),
    formData
  )
}
const put_To_CargosController = jsonparameters => {
  return put(
    `${url.PUT_TO_CARGOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const del_From_CargosController = jsonparameters => {
  return del(
    `${url.DELETE_FROM_CARGOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

//
const post_To_WhatsAppController = data => {
  return post(url.POST_TO_WHATSAPPCONTROLLER, data)
}

const post_To_DashboardController = data => {
  return post(url.POST_FROM_DASHBOARDCONTROLLER, data)
}

// Contribuyentes_Controller
const get_From_ContribuyentesController = jsonparameters => {
  return get(
    `${url.GET_FROM_CONTRIBUYENTESCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_ContribuyentesController = jsonparameters => {
  return post(
    `${url.POST_TO_CONTRIBUYENTESCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_ContribuyentesController_FormData = (
  jsonparameters,
  formData
) => {
  return postFormData(
    `${url.POST_TO_CONTRIBUYENTESCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters),
    formData
  )
}
const put_To_ContribuyentesController = jsonparameters => {
  return put(
    `${url.PUT_TO_CONTRIBUYENTESCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const del_From_ContribuyentesController = jsonparameters => {
  return del(
    `${url.DELETE_FROM_CONTRIBUYENTESCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

// Documentos_Controller
const get_From_DocumentosController = jsonparameters => {
  return get(
    `${url.GET_FROM_DOCUMENTOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_DocumentosController = jsonparameters => {
  return post(
    `${url.POST_TO_DOCUMENTOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_DocumentosController_FormData = (jsonparameters, formData) => {
  return postFormData(
    `${url.POST_TO_DOCUMENTOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters),
    formData
  )
}
const put_To_DocumentosController = jsonparameters => {
  return put(
    `${url.PUT_TO_DOCUMENTOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const del_From_DocumentosController = jsonparameters => {
  return del(
    `${url.DELETE_FROM_DOCUMENTOSCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

const get_From_CredencialesController = jsonparameters => {
  return get(
    `${url.GET_FROM_CREDENCIALESCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

const post_CredencialesController = data =>
  post(url.POST_CREDENCIALESCONTROLLER, data)

// Alumnos {"nombreSolicitud":"getlistaalumnos","idCampus":5}
const getListaCredenciales = jsonparameters => {
  return get(
    `${url.GET_LISTA_CREDENCIALES}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

// Alumnos {"nombreSolicitud":"getlistaalumnos","idCampus":5}
const getListaAlumnos = jsonparameters => {
  //console.log("getListaAlumnos::jsonparameters: ", jsonparameters)
  return get(
    `${url.GET_LISTA_ALUMNOS}/?jsonparameters=` + JSON.stringify(jsonparameters)
  )
}

const getListaCampus = jsonparameters => {
  return get(
    `${url.GET_LISTA_CAMPUS}/?jsonparameters=` + JSON.stringify(jsonparameters)
  )
}

const getCajaEstadoCuenta = jsonparameters => {
  return get(
    `${url.GET_ESTADO_CUENTA}/?jsonparameters=` + JSON.stringify(jsonparameters)
  )
}

const get_From_CajaController = jsonparameters => {
  return get(
    `${url.GET_FROM_CAJACONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const del_From_CajaController = jsonparameters => {
  return get(
    `${url.DELETE_CAJACONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

const get_From_ControlEscolarController = jsonparameters => {
  return get(
    `${url.GET_FROM_CONTROLESCOLARCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_ControlEscolarController = jsonparameters => {
  return post(
    `${url.POST_TO_CONTROLESCOLARCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const put_To_ControlEscolarController = jsonparameters => {
  return put(
    `${url.PUT_TO_CONTROLESCOLARCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const del_From_ControlEscolarController = jsonparameters => {
  return del(
    `${url.DELETE_FROM_CONTROLESCOLARCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

// AlumnoController
const get_From_AlumnoController = jsonparameters => {
  return get(
    `${url.GET_FROM_ALUMNOCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_AlumnoController = data => {
  return post(url.POST_TO_ALUMNOCONTROLLER, data)
}
const put_To_AlumnoController = jsonparameters => {
  return put(
    `${url.PUT_TO_ALUMNOCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const del_From_AlumnoController = jsonparameters => {
  return del(
    `${url.DELETE_FROM_ALUMNOCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

const get_From_PersonaController = jsonparameters => {
  return get(
    `${url.GET_FROM_PERSONACONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const put_From_PersonaController = jsonparameters => {
  return put(
    `${url.PUT_FROM_PERSONACONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_From_PersonaController = jsonparameters => {
  return post(
    `${url.POST_FROM_PERSONACONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const post_To_FileController = (jsonparameters, formData) => {
  // console.log("formData:", formData)
  // console.log("stringify::formData:", JSON.stringify(formData))
  return postFormData(
    `${url.POST_TO_FILECONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters),
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  )
}
const post_From_PhotoControllerworking = formData => {
  return postFormData(url.POST_FROM_PHOTOCONTROLLER, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}
const del_From_PersonaController = jsonparameters => {
  return del(
    `${url.DELETE_FROM_PERSONACONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

const get_From_DashboardController = jsonparameters => {
  return get(
    `${url.GET_FROM_DASHBOARDCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

const get_From_CampusVirtualController = jsonparameters => {
  return get(
    `${url.GET_FROM_CAMPUSVIRTUALCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

const post_To_CampusVirtualController = jsonparameters => {
  return post(
    `${url.POST_TO_CAMPUSVIRTUALCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const put_To_CampusVirtualController = jsonparameters => {
  return put(
    `${url.PUT_TO_CAMPUSVIRTUALCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}
const del_From_CampusVirtualController = jsonparameters => {
  return del(
    `${url.DELETE_FROM_CAMPUSVIRTUALCONTROLLER}/?jsonparameters=` +
      JSON.stringify(jsonparameters)
  )
}

const post_CajaController = data => post(url.POST_CAJACONTROLLER, data)

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// get id contacto del usuario autentificado
const getIdContactoUserAuthenticated = () => {
  const UserAuthenticated = getLoggedInUser()
  return UserAuthenticated ? UserAuthenticated.idContacto : -1
}

// Get oSolicitudBase, para que se hagan todas las llamadas al api con esa base
const getoSolicitudBase = (
  Descripcion_Bitacora = "",
  Comando = "",
  Datos = [],
  Parametros = []
) => {
  const idContacto = isUserAuthenticated
    ? getIdContactoUserAuthenticated().toString()
    : "-1"
  const oSolicitudBase = {
    id_Contacto: idContacto ? idContacto : -1,
    Descripcion_Bitacora: Descripcion_Bitacora,
    Comando: Comando,
    Datos: Datos,
    Parametros: Parametros,
  }
  return oSolicitudBase
}

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data)

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data)

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data)

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data)

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      var message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
//const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data)
// Login Method
// https://{{urlServer}}/api/authenticate/login?id_Colegio={{id_colegio}}&username={{username}}&password=L0ZJcGtyVXk4I0FW
const postJwtLogin = user =>
  get(
    `${url.GET_USERNAME_PASSWORD_LOGIN}/?id_Colegio=${
      user.id_colegio
    }&username=${user.email}&password=${btoa(user.password)}`
  )

const postJwtLogin2 = data => post(url.GET_USERNAME_PASSWORD_LOGIN, data)

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data)

// postSocialLogin
const postSocialLogin = data =>
  get(
    `${url.GET_FROM_AUTHENTICATECONTROLLER}/?id_Colegio=${data.id_colegio}&provider=${data.provider}&access_token=${data.access_token}&GMT_Offset=${data.GMT_Offset}`
  )

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getListaAlumnos,
  getCajaEstadoCuenta,
  getListaCampus,
  get_From_CajaController,
  postSocialLogin,
  postJwtLogin2,
  post_CajaController,
  get_From_DashboardController,
  get_From_CredencialesController,
  post_CredencialesController,
  getListaCredenciales,
  del_From_CajaController,
  get_From_PersonaController,
  post_From_PersonaController,
  del_From_PersonaController,
  put_From_PersonaController,
  post_To_FileController,
  post_From_PhotoControllerworking,
  get_From_ControlEscolarController,
  post_To_ControlEscolarController,
  put_To_ControlEscolarController,
  del_From_ControlEscolarController,
  get_From_CampusVirtualController,
  post_To_CampusVirtualController,
  put_To_CampusVirtualController,
  del_From_CampusVirtualController,
  get_From_DocumentosController,
  post_To_DocumentosController,
  post_To_DocumentosController_FormData,
  put_To_DocumentosController,
  del_From_DocumentosController,
  get_From_ContribuyentesController,
  post_To_ContribuyentesController,
  post_To_ContribuyentesController_FormData,
  put_To_ContribuyentesController,
  del_From_ContribuyentesController,
  get_From_CargosController,
  post_To_CargosController,
  post_To_CargosController_FormData,
  put_To_CargosController,
  del_From_CargosController,
  get_From_AlumnoController,
  post_To_AlumnoController,
  put_To_AlumnoController,
  del_From_AlumnoController,
  post_To_WhatsAppController,
  post_To_DashboardController,
}
